import { getSingleFieldValue } from '../utils';
import { useCFField } from './use-field';
export const useCFTextField = (name, initialValue, hookOptions) => {
    const field = useCFField(name, initialValue, hookOptions);
    const { onChange, value: fieldValue, validationState } = field;
    const value = getSingleFieldValue(fieldValue);
    return Object.assign(Object.assign({}, field), { fieldProps: {
            name,
            onChange,
            validationState,
            value,
        }, fieldType: 'text', onChange,
        value });
};
